import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../utils/userProvider";
import axios from "axios";

export default function useTransactions(year = "last12months") {
  let backend_url;

  if (year === "last12months") {
    // Calculate dates for the past year
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    backend_url = `${
      process.env.REACT_APP_BACKEND_URL
    }/transactions?_sort=createdAt:DESC&status_ne=expired&rms_manual_ne=true&createdAt_gte=${oneYearAgo.toISOString()}&createdAt_lte=${today.toISOString()}`;
  } else {
    // If year is not provided, get current year
    const targetYear = year || new Date().getFullYear();
    const startDate = `${targetYear}-01-01T00:00:00.000Z`;
    const endDate = `${targetYear}-12-31T23:59:59.999Z`;
    backend_url = `${process.env.REACT_APP_BACKEND_URL}/transactions?_sort=createdAt:DESC&status_ne=expired&rms_manual_ne=true&createdAt_gte=${startDate}&createdAt_lte=${endDate}`;
  }

  const { authState, setAuthState } = useContext(AuthContext);
  const [res, setRes] = useState({
    data: null,
    complete: false,
    loading: false,
    error: false,
  });

  const [resetCount, setResetCount] = useState(0);

  const reset = () => {
    var newResetCount = resetCount + 1;
    setResetCount(newResetCount);
  };

  useEffect(() => {
    setRes({
      data: null,
      loading: true,
      error: false,
      complete: false,
    });
    axios({
      url: backend_url,
      method: "GET",
      headers: {
        Authorization: `Bearer ${authState.jwt ? authState.jwt : ""}`,
      },
    })
      .then((res) =>
        setRes({
          data: res.data,
          loading: false,
          error: false,
          complete: true,
        })
      )
      .catch((e) =>
        setRes({
          data: null,
          loading: false,
          error: true,
          errorMessage: e.response,
          complete: true,
        })
      );
  }, [resetCount, year]);

  return [res, reset];
}
